import { lineTagId } from "config/const";

export const sendLineTag = (type, params) => {
  if (typeof window === "undefined") return;

  const lt = window._lt;

  if (!lt) return;

  const payload = {
    type,
    ...(params || {}),
  };

  lt("send", "cv", payload, [lineTagId]);
};
